// my datatatatat
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { messages } from '../../../../common/messages';
import TwoStatement from '../../../../Components-2025/IR/TwoStatement';
import appRoutes from '../../../../routes/exams/gmat-focus/app-routes';
import { apiServices } from './utils/twoStatementServices';
import { examNameAccordingToDB, QUESTION_TYPE } from '../../../../common/constant';

class Table extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  redirectTo = (path) => {
    const { router } = this.context;
    const { chapterid, readingid, subscription, reading } = this.props.params;

    const routes = {
      question: appRoutes.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid)
        .replace(':id', readingid)
        .replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free')
        .replace(':reading', reading),

      reading: appRoutes.QUESTION_BANK_READING.replace(':id', chapterid),
    };

    if (routes[path]) {
      router.push({ pathname: routes[path] });
    }
  };
  handleChangeParams = (value) => {
    const { index, question_id } = value;
    const { chapterid, readingid, subscription, reading } = this.props.params;
    this.context.router.push({
      pathname: appRoutes.TABLE.replace(':chapterid', chapterid)
        .replace(':readingid', readingid)
        .replace(':subscription', subscription)
        .replace(':question_id', question_id)
        .replace(':offset', index)
        .replace(':reading', reading),
    });
  };

  render() {
    return (
      <div>
        <TwoStatement
          {...this.props}
          examName={examNameAccordingToDB.GMAT_FOCUS}
          apiServices={apiServices}
          questionType={QUESTION_TYPE.TABLE_QUESTION}
          redirectTo={this.redirectTo}
          handleChangeParams={this.handleChangeParams}
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/views/GMATFocus/QuestionBank/SpecialQuestions/GMATTable.js